export default __webpack_public_path__ + "static/media/kycDisable.47b8efb4.svg";